<template>
    <div class="img-box">
        <img :src="imgSrc">
    </div>
</template>

<script setup>
    import {computed} from 'vue'

    // const emits = defineEmits(['logout-complete'])
    const props = defineProps(["imgSrc"])

    const imgSrc = computed(() => {
        let src = ""

        if (null != props.imgSrc){
            return props.imgSrc
        }

        return src
    })
</script>

<style scoped>
    .img-box {
        width: 100%;
        height: 100%;
        background: #fff;
    }

    .img-box img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
    }
</style>